// extracted by mini-css-extract-plugin
export default {"activitiesContainer":"GraphItem_activitiesContainer__vspnO"};